export default function Footer() {
  return (
    <footer className="w-full bg-[#123f43] text-gray-200">
      <div className="w-full px-6 py-6 text-center space-y-3 min-h-[96px]">
        <p className="text-sm">
          Road to La Défense — parce que comprendre comment rejoindre les métiers d'élite en finance ne devrait pas être réservé à ceux qui ont les bons réseaux.
        </p>
        <p className="text-sm">
          <a href="mailto:contact@road-to-la-defense.fr" className="underline hover:text-white">
            contact@road-to-la-defense.fr
          </a>
        </p>
        <p className="text-xs text-white/55 mt-4">© {new Date().getFullYear()} Road to La Défense</p>
      </div>
    </footer>
  );
}
